<template>
  <div>
    <loading :active.sync="isLoading" color="#64B9B0"></loading>
    <div class="content-wrapper">
      <div class="container-fluid">
        <!-- Breadcrumbs-->
         <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/adm_master/usuarios">Usuarios</router-link>
          </li>
          <li class="breadcrumb-item active">Criar novo Usuário</li>
        </ol>


        <div class="box_general padding_bottom mb-5">
          <div class="header_box version_2">
            <h2>
              <i class="fa fa-info-circle"></i>Informações do Usuário
            </h2>
          </div>

          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>Nome</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="usuario.name"
                />
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label>E-Mail</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="usuario.email"
                />
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label>Telefone</label>
                <input
                  class="form-control"
                  v-model="usuario.telefone"
                  type="text"
                  v-mask="maskTel()"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>Senha</label>
                <input
                  class="form-control"
                  v-model="usuario.password"
                  type="password"
                />
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label>Confirme sua senha</label>
                <input
                  class="form-control"
                  v-model="usuario.confirmaPassword"
                  type="password"
                />
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label>Tipo de Usuário</label>
                <v-select
                  label="option"
                  v-model="usuario.role"
                  class="form-select"
                  :reduce="options => options.id"
                  :options="options"
                  :searchable="true"
                >
                </v-select> 
              </div>
            </div>
          </div>

          <div v-if="usuario.role === 2" class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>Empresa</label>
                <v-select
                  label="nome_empresa"
                  v-model="usuario.empresas_id"
                  class="form-select"
                  :reduce="empresas => empresas.id"
                  :options="empresas"
                  :searchable="true"
                >
                </v-select> 
              </div>
            </div>
          </div>

        <div class="col-md-12 mb-4">
          <p>
            <button href="#0" class="btn_1 medium pull-right" @click="criarUsuario()">Salvar</button>
          </p>
        </div>
      </div>
    </div>
  </div> <!-- /container-fluid-->
</div>
</template>

<script>
import { ajax, tratamento_requisicao, alerta, validaCampos, confereSenha, stripTelefone } from "@/utils/util";
import funcoesGerais from "@/assets/js/funcoes.js";
import axios from 'axios';

export default {
  mixins: [funcoesGerais],
  data() {
    return {
      isLoading: false,
      usuario: {
        name: '',
        password: '',
        confirmaPassword: '',
        telefone: '',
        email: '',
        role: null,
        empresas_id: null
      },
      options: [
        { option: 'Master', id: 1 },
        { option: 'Empresa', id: 2 }
      ],
      empresas: []
    };
  },

  mounted() {
    axios.get('empresas')
      .then((res) => {
        this.empresas = res.data;
        this.isLoading = false;
      }, err => {
        this.isLoading = false;
        tratamento_requisicao(err);
      })
  },

  methods: {
    maskTel() {
      let self = this;
      if(self.usuario.telefone)
        return self.usuario.telefone.length == 15 ? '(##) #####-####' : '(##) ####-####'
    },
    criarUsuario() {
      let self = this;

      if(validaCampos(self.usuario.email, undefined, self.usuario.telefone, undefined) && 
        confereSenha(self.usuario.password, self.usuario.confirmaPassword)){
        
        if(self.usuario.name && self.usuario.password && self.usuario.telefone && self.usuario.email !== '' &&
        (self.usuario.role === 1 || (self.usuario.role === 2 && self.usuario.empresas_id !== null))) {
          self.isLoading = true;
          let objRequest = new FormData();

          objRequest.append('name', self.usuario.name);
          objRequest.append('password', self.usuario.password);
          objRequest.append('telefone', stripTelefone(self.usuario.telefone));
          objRequest.append('email', self.usuario.email);
          objRequest.append('role', self.usuario.role);

          if (self.usuario.empresas_id)
            objRequest.append('empresas_id', self.usuario.empresas_id);
          
          ajax("post", "users", objRequest)
            .then(response => {
              self.isLoading = false;
              let id_user = response.id;
              alerta(
                "success",
                "Sucesso",
                "Usuário cadastrado!"
              );
              self.$router.replace(this.$route.query.redirect || `/adm_master/usuarios/${id_user}`);
            })
            .catch(error => {
              self.isLoading = false;
              tratamento_requisicao(error);
            });
        } else {
          alerta('warning', 'Atenção', 'Preencha todos os campos');
        }
      }
    },
  }
};
</script>
